document.addEventListener('DOMContentLoaded', function () {
  const prevBtn = document.querySelector('.swiper-button-prev');
  const nextBtn = document.querySelector('.swiper-button-next');
  const slider = document.querySelector('.shop-by-sport-grid-wrapper.slider');
  if (!prevBtn || !nextBtn || !slider) return;

  const scrollAmount = 300;

  prevBtn.addEventListener('click', () => {
    slider.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });

  nextBtn.addEventListener('click', () => {
    slider.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });

  function checkButtons() {
    if (slider.scrollLeft <= 0) {
      prevBtn.setAttribute('aria-disabled', 'true');
      prevBtn.style.pointerEvents = 'none';
      prevBtn.style.opacity = '0.4';
    } else {
      prevBtn.setAttribute('aria-disabled', 'false');
      prevBtn.style.pointerEvents = '';
      prevBtn.style.opacity = '1';
    }

    if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1) {
      nextBtn.setAttribute('aria-disabled', 'true');
      nextBtn.style.pointerEvents = 'none';
      nextBtn.style.opacity = '0.4';
    } else {
      nextBtn.setAttribute('aria-disabled', 'false');
      nextBtn.style.pointerEvents = '';
      nextBtn.style.opacity = '1';
    }
  }

  // Focus first interactive element in the card nearest to the left edge after scroll
  let scrollTimeout;
  slider.addEventListener('scroll', () => {
    checkButtons();

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const cards = Array.from(slider.querySelectorAll('.sport-card'));
      const sliderLeft = slider.scrollLeft;
      // Find card closest to current scrollLeft (left edge)
      let closestCard = null;
      let closestDistance = Infinity;

      cards.forEach(card => {
        const cardLeft = card.offsetLeft;
        const distance = Math.abs(cardLeft - sliderLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestCard = card;
        }
      });

      if (closestCard) {
        const shopButton = closestCard.querySelector('.shop-button');
        if (shopButton) shopButton.focus();
      }
    }, 150); // Debounce 150ms after scrolling stops
  });

  // Initial check
  checkButtons();

  // Keyboard navigation for slider (left/right arrows)
  document.addEventListener('keydown', (e) => {
    // Only act if slider or buttons are focused (optional: or always listen)
    if (document.activeElement === slider || document.activeElement === prevBtn || document.activeElement === nextBtn) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  });
});
